<template>
  <div class="mit-documents-page mit-page">
      <v-container fluid>
      <v-row no-gutters>
        <v-col cols="12" class="d-flex">
          <v-card class="mit-info-card">
            <v-card-title>Documentation</v-card-title>
            <v-card-subtitle class="caption">CSAIL Documentation Information</v-card-subtitle>
            <v-divider></v-divider>
            <v-card-text>
              <h3 class="pt-5">
                <a href="https://tig.csail.mit.edu/" target="_blank">
                TIG documentation
                </a>
              </h3>
              <p>The Infrastructure Group (TIG) information and documentation</p>


            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>

  export default {
    name: 'MitDocumentsPage',
    components: {
    },
    data: function() {
      return {
      }
    },
    mounted() {
    },
    methods: {
      // exampleFunction: function(model) {
      //   console.log(model);
      // }
    }
  }
</script>

<style lang="scss" scoped>
  .mit-info-card {
    width:100%;
    height:100%;
  }
</style>
